export default {
  Login: {
    user: '사용자',
    password: '비밀번호',
    required: '필수입력항목입니다.',      //'필수 입력항목입니다.'
    loginFail: '사용자 혹은 비밀번호가 틀립니다',
    submit: '확인'
  },
  Dashboard: {
    dashboard: '대시보드',
    os: '운영체계',
    architecture: '아키텍쳐',
    processor: '프로세서',
    address: '주소',
    memory: '메모리',
    storage: '스토리지'
  },
  channel: {
    configuration: '설정',
    configurator: '설정',

    driver: '드라이버',
    driverid: '드라이버 이름',
    driverid_tip: '중복되지 않는 드라이버 이름',
    driver_specific: '드라이버 관련 설정',

    select: '드라이버 선택',
    select_tip: '드라이버를 선택합니다.',

    device: '디바이스',
    deviceid: '디바이스 이름',
    deviceid_tip: '중복되지 않는 디바이스 이름',
    description: '설명',
    description_tip: '장치에 대한 설명',
    settings: '세팅',
    settings_tip: '장치 작동에 필요한 세팅',

    channel: '채널',
    channelid: '채널 이름',
    channelid_tip: '중복되지 않는 채널 이름',

    samplingtimeout: '샘플링 타임아웃 시간',
    retryInterval: '재접속 대기 시간',
    disabled: '비활성화',

    samplingtimeout_tip: '샘플링 완료까지 대기 시간을 지정합니다.',
    retryInterval_tip: '연결 실패 시 재 접속 대기 시간을 지정합니다.',
    disabled_tip: '비활성화 지정 시 이 드라이버의 모든 작업을 중단합니다.',

    add: '추가',
    edit: '설정 변경',
    save: '저장',
    remove: '삭제',
    second: '초',
    status: '상태'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/kr.js